import script from "./ManagersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagersList.vue?vue&type=script&lang=ts&setup=true"

import "./ManagersList.vue?vue&type=style&index=0&id=4f5b10ac&lang=scss&scoped=true"
script.__scopeId = "data-v-4f5b10ac"

export default script